module.exports = __webpack_public_path__ + "static/media/zoleWon_50_75.9edf72a7.png";